// src/components/Footer.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [showBio, setShowBio] = useState(false);

  return (
    <footer style={{ background:'rgba(255,255,255,0.02)', borderTop:'1px solid rgba(255,255,255,0.07)', padding:'32px 24px', marginTop:'auto' }}>
      <div style={{ maxWidth:1200, margin:'0 auto', display:'flex', flexDirection:'column', gap:20 }}>

        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:16 }}>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <div style={{ width:32, height:32, borderRadius:9, background:'linear-gradient(135deg,#FF2D2D,#FF8C00)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:16 }}>&#127968;</div>
            <span style={{ fontWeight:800, color:'#FF8C00' }}>Vuelve A Casa RD</span>
          </div>
          <div style={{ display:'flex', gap:20 }}>
            <Link to="/" style={{ fontSize:13, color:'#555' }}>Inicio</Link>
            <Link to="/casos" style={{ fontSize:13, color:'#555' }}>Casos</Link>
            <Link to="/reportar" style={{ fontSize:13, color:'#555' }}>Reportar</Link>
          </div>
          <div style={{ fontSize:13, color:'#555' }}>
            Emergencias: <strong style={{ color:'#FF6B6B' }}>9-1-1</strong>
          </div>
        </div>

        <div style={{ background:'rgba(255,140,0,0.06)', borderRadius:10, padding:'14px 18px', border:'1px solid rgba(255,140,0,0.12)' }}>
          <p style={{ fontSize:12, color:'#888', lineHeight:1.7, margin:0 }}>
            Vuelve A Casa RD es una plataforma ciudadana creada para centralizar y difundir casos de personas desaparecidas en la Republica Dominicana. Nace de la conviccion de que muchas personas quedan en el olvido por no existir un espacio donde todos los casos esten publicados y accesibles para la ciudadania.
          </p>
        </div>

        <div style={{ borderTop:'1px solid rgba(255,255,255,0.05)', paddingTop:16 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:10, marginBottom: showBio ? 14 : 0 }}>
            <div style={{ fontSize:12, color:'#555' }}>
              Desarrollado por{' '}
              <button onClick={() => setShowBio(!showBio)} style={{ background:'none', border:'none', color:'#FF8C00', fontSize:12, cursor:'pointer', padding:0, fontWeight:600 }}>
                Pedro Miguel Lara Peguero
              </button>
              {' '}y{' '}
              <button onClick={() => setShowBio(!showBio)} style={{ background:'none', border:'none', color:'#FF8C00', fontSize:12, cursor:'pointer', padding:0, fontWeight:600 }}>
                Juan Isidro Perez
              </button>
              {' '}
              <span style={{ color:'#444', cursor:'pointer' }} onClick={() => setShowBio(!showBio)}>{showBio ? '[cerrar]' : '[ver]'}</span>
            </div>
            <span style={{ fontSize:12, color:'#444' }}>
              &copy; {new Date().getFullYear()} Vuelve A Casa RD
            </span>
          </div>

          {showBio && (
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginTop:14 }} className="bio-grid">
              <div style={{ background:'rgba(255,255,255,0.03)', borderRadius:10, padding:14, border:'1px solid rgba(255,255,255,0.06)' }}>
                <p style={{ fontSize:12, fontWeight:700, color:'#FF8C00', marginBottom:8 }}>Pedro Miguel Lara Peguero</p>
                <p style={{ fontSize:11, color:'#666', lineHeight:1.7, margin:0 }}>
                  Developer con amplia experiencia en el sector tecnologico, docente de Hebreo Biblico y Griego Koine, creador del podcast La Hora Tecnologica (@pedrolaradev). Junto a Juan Isidro Perez vio la necesidad de crear una plataforma que diera visibilidad a casos de personas desaparecidas que de otra manera quedarian en el olvido.
                </p>
              </div>
              <div style={{ background:'rgba(255,255,255,0.03)', borderRadius:10, padding:14, border:'1px solid rgba(255,255,255,0.06)' }}>
                <p style={{ fontSize:12, fontWeight:700, color:'#FF8C00', marginBottom:8 }}>Juan Isidro Perez</p>
                <p style={{ fontSize:11, color:'#666', lineHeight:1.7, margin:0 }}>
                  Cofundador de Vuelve A Casa RD. Junto a Pedro Lara identifico la ausencia de una plataforma centralizada donde todos los casos de personas desaparecidas en Republica Dominicana estuvieran disponibles para la ciudadania, y se unio a esta iniciativa para contribuir a que menos familias queden sin respuesta.
                </p>
              </div>
            </div>
          )}
        </div>

      </div>

      <style>{`
        @media (max-width: 640px) {
          .bio-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
}
